import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Modules
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TableModule } from 'primeng/table';
import { ClipboardModule } from 'ngx-clipboard';
import { AvatarModule } from 'primeng/avatar';
import { ContextMenuModule } from 'primeng/contextmenu';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

// Pipes
import { DateAgoPipe } from '@app/pipes/date-ago.pipe';
import { BoolConvertPipe } from '@app/pipes/bool-convert.pipe';
import { GetFirstLetterPipe } from '@app/pipes/get-first-letter.pipe';
import { SafeHtmlPipe } from '@app/pipes/sanitize.pipe';
import { PluralPipe } from "@app/pipes/plural.pipe";
import { ByteConvertPipe } from '@app/pipes/byte-convert.pipe';

// Components
import { ChatComponent } from '@app/views/pages/apps/chat/chat.component';
import { ChatManageComponent } from '@app/views/pages/apps/admin-chat/chat.component';
import { ChatSupportComponent } from '@app/views/pages/apps/chat-support/chat.component';
import { ChatSupportManageComponent } from '@app/views/pages/apps/admin-support/chat.component';
import { ControlMessagesComponent } from '@app/views/pages/apps/form-control/control-message.component';

// Directives
import { OnlyNumbersDirective, PaypalDisableDirective, FaviconLoadDirective, TextareaAutoresizeDirective, ClickPreviewDirective, ShowStatusDirective, GetLanguageDirective, QuillFixedToolbarDirective, NoNegativeDirective } from '@app/directives';

@NgModule({
  declarations: [
    //components
    ControlMessagesComponent,
    ChatComponent,
    ChatManageComponent,
    ChatSupportComponent,
    ChatSupportManageComponent,
    //directives
    OnlyNumbersDirective, 
    PaypalDisableDirective,
    FaviconLoadDirective,
    TextareaAutoresizeDirective,
    ClickPreviewDirective,
    ShowStatusDirective,
    GetLanguageDirective,
    QuillFixedToolbarDirective,
    NoNegativeDirective,
    //pipes
    DateAgoPipe,
    BoolConvertPipe,
    GetFirstLetterPipe,
    SafeHtmlPipe,
    PluralPipe,
    ByteConvertPipe
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ClipboardModule,
    PerfectScrollbarModule,
    AvatarModule,
    ContextMenuModule
  ],
  exports: [
    //components
    ControlMessagesComponent,
    ChatComponent,
    ChatManageComponent,
    ChatSupportComponent,
    ChatSupportManageComponent,
    //modules
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ClipboardModule,
    ContextMenuModule,
    //directives
    OnlyNumbersDirective, 
    PaypalDisableDirective,
    FaviconLoadDirective,
    TextareaAutoresizeDirective,
    ClickPreviewDirective,
    ShowStatusDirective,
    GetLanguageDirective,
    QuillFixedToolbarDirective,
    NoNegativeDirective,
    //pipes
    DateAgoPipe,
    BoolConvertPipe,
    GetFirstLetterPipe,
    SafeHtmlPipe,
    PluralPipe,
    ByteConvertPipe
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class SharedModule { }